import React from "react";
import Pinterest from "../images/Pinterest.png";
import gmail from "../images/gmail.png";
import Recipe from "../images/RecipeApp.png";
import Movie from "../images/Movie-explorer-2.png";
import Covid from "../images/covid.PNG";

function Projects() {
  return (
    <div id="Projects" className="mt-4">
      <h1 className="text-center">Projects</h1>
      <div className="container mb-5">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                src={Pinterest}
                onClick={() => {
                  window.open("https://pinterest-app.netlify.app");
                }}
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">Pinterest App</h4>
                <p class="card-text">
                  Pinterest App is Pinterest clone where you can view all pins
                  posted by users, add your fav images(pins) with Sign up and
                  Login
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-react"></i>
                  <i class="fab fa-node-js"></i>
                  <i class="fab fa-bootstrap"></i>
                </small>
                <a
                  className="mt-1 source"
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/chetas11/Pinterest_Clone_Frontend"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                src={Recipe}
                onClick={() => {
                  window.open("https://receipeapp.netlify.app");
                }}
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">Recipe App</h4>
                <p class="card-text">
                  Recipe App using React where you can view recipes, add new
                  recipes, delete recipes, edit recipes with local storage of
                  browser
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-react"></i>
                  <i class="fab fa-js"></i>
                  <i class="fab fa-bootstrap"></i>
                </small>
                <a
                  className="mt-1 source"
                  href="https://github.com/chetas11/ReceipeApp"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                src={Movie}
                onClick={() => {
                  window.open("https://movie-explorer-chetas11.netlify.app");
                }}
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">Movie Explorer App</h4>
                <p class="card-text">
                  Movie Explorer app using OMDB API (The Open Movie Database)
                  where you can search for any Movie/Tv-series and get all the
                  details about it like rating, cast, plot, director etc.
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-react"></i>
                  <i class="fab fa-js"></i>
                  <i class="fab fa-bootstrap"></i>
                </small>
                <a
                  className="mt-1 source"
                  href="https://github.com/chetas11/MovieExplorer"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                onClick={() => {
                  window.open("https://frozen-citadel-90146.herokuapp.com");
                }}
                src="https://raw.githubusercontent.com/chetas11/URL_Shortner/master/Screenshot.png"
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">URL Shortner App</h4>
                <p class="card-text">
                  URL shortening is a technique on the World Wide Web in which a
                  URL may be made substantially shorter and still direct to the
                  required page.
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-node-js"></i>
                  <i class="fab fa-js"></i>
                  <i class="fab fa-bootstrap"></i>
                </small>
                <a
                  className="mt-1 source"
                  href="https://github.com/chetas11/URL_Shortner"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                onClick={() => {
                  window.open("https://covid-tracker-chetas11.netlify.app");
                }}
                src={Covid}
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">Covid Tracker</h4>
                <p class="card-text">
                  Live Covid tracker fetch the count of people Infected,
                  Recoverd and death caused by Covid-19 using Chart Js and React
                  also can filter the count according to countries
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-js"></i>
                  <i class="fab fa-react"></i>
                  <i class="fab fa-node-js"></i>
                </small>
                <a
                  className="mt-1 source"
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/chetas11/covidtracker"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 my-3">
            <div class="card h-100">
              <img
                onClick={() => {
                  window.open("https://gmail-clone-chetanbirmole.netlify.app");
                }}
                src={gmail}
                class="card-img-top"
                alt="..."
              />
              <div class="card-body .card-body-border">
                <h4 class="card-title text-center">Gmail Clone App</h4>
                <p class="card-text">
                  Clone of gmail website using the Gmail API where you can fetch
                  all your the mails, search mails, compose mails and send to
                  anyone, get all the mails according to labels you specified
                </p>
              </div>
              <div class="card-footer">
                <small class="text-muted">
                  <i class="fab fa-css3-alt"></i>
                  <i class="fab fa-js"></i>
                  <i class="fab fa-node-js"></i>
                  <i class="fab fa-bootstrap"></i>
                </small>
                <a
                  className="mt-1 source"
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/chetas11/Gmail_Clone"
                >
                  Source Code
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default Projects;
